import EventEmitter from './../../util/event-emitter';

const eventHub = new EventEmitter();

export default eventHub;
